module.exports = __webpack_public_path__ + "assets/703630fb2e474adffa228049dd90c166.png";